import _ from 'lodash'
import { IOptionNumberItem, IPageData, IPageParams } from "../types"
import { E_SensorKlass } from "./sensor.types"
import { E_SyncCollectStatus } from './sensorNew.types'

/**
 * SIM卡状态位
 * $t('enum.E_SimStatus.SimOffline_NetworkUnRegister')
 * $t('enum.E_SimStatus.SimOnline_NetworkUnRegister')
 * $t('enum.E_SimStatus.SimOffline_NetworkRegister')
 * $t('enum.E_SimStatus.SimOnline_NetworkRegister')
 */
export enum E_SimStatus {
    /**
     * SIM卡不在位状态，网络未注册状态
     */
    SimOffline_NetworkUnRegister = 0,
    /**
     * SIM卡在位状态，网络未注册状态
     */
    SimOnline_NetworkUnRegister = 1,
    /**
     * SIM卡不在位状态，网络已注册状态
     */
    SimOffline_NetworkRegister = 2,
    /**
     * SIM卡在位状态，网络已注册状态
     */
    SimOnline_NetworkRegister = 3,
}

/**
 * Sim卡在位状态
 * $t('enum.E_SimOnlineStatus.Online')
 * $t('enum.E_SimOnlineStatus.Offline')
 */
export enum E_SimOnlineStatus {
    /**
     * SIM卡在位
     */
    Online = 1,
    /**
     * SIM卡不在位
     */
    Offline = 0,
}

/**
 * Sim卡网络注册状态
 * $t('enum.E_SimNetworkRegisterStatus.UnRegister')
 * $t('enum.E_SimNetworkRegisterStatus.Register')
 */
export enum E_SimNetworkRegisterStatus {
    /**
     * 网络未注册
     */
    UnRegister = 0,
    /**
     * 网络已注册
     */
    Register = 1,
}


/**
 * $t('enum.E_GatewayDHCPModel.DHCP')
 * $t('enum.E_GatewayDHCPModel.Static')
 */
export enum E_GatewayDHCPModel {
    DHCP = 0,
    Static = 1,
}

/**
 * 数据格式
 * $t('enum.E_GatewayDataFormat.Raw')
 * $t('enum.E_GatewayDataFormat.Json')
 */
export enum E_GatewayDataFormat {
    /**
     * 透传
     */
    Raw = 0,
    /**
     * 
     */
    Json = 1
}
/**
 * $t('enum.E_OfflineDataStatus.Allow')
 * $t('enum.E_OfflineDataStatus.DisAllow')
 */
export enum E_OfflineDataStatus {
    /**
     * 允许
     */
    Allow = 1,
    /**
     * 不允许
     */
    DisAllow = 0
}

/**
 * 传感器注册状态
 * $t('enum.E_SensorRegisterStatus.Allow')
 * $t('enum.E_SensorRegisterStatus.DisAllow')
 */
export enum E_SensorRegisterStatus {
    /**
     * 允许
     */
    Allow = 1,
    /**
     * 不允许
     */
    DisAllow = 0
}


/**
 * 传输协议类型
 * $t('enum.E_GatewayTranslateProtocol.TCP')
 * $t('enum.E_GatewayTranslateProtocol.MQTT')
 * $t('enum.E_GatewayTranslateProtocol.ModbusTCP')
 * $t('enum.E_GatewayTranslateProtocol.ModbusRTU')
 */
export enum E_GatewayTranslateProtocol {
    TCP = 0,
    MQTT = 1,
    ModbusTCP = 2,
    ModbusRTU = 3,
}

/**
 * 带宽
 * $t('enum.E_LoraBandwidth.Hz_125KHz')
 * $t('enum.E_LoraBandwidth.Hz_250KHz')
 * $t('enum.E_LoraBandwidth.Hz_500KHz')
 */
export enum E_LoraBandwidth {
    Hz_125KHz = '7',
    Hz_250KHz = '8',
    Hz_500KHz = '9',
}

export const E_LoraBandwidthInverse = _.invert(E_LoraBandwidth)

/**
 * 低速优化
 * $t('enum.E_LoraLowSpeedOpt.Default')
 * $t('enum.E_LoraLowSpeedOpt.Open')
 * $t('enum.E_LoraLowSpeedOpt.Close')
 */
export enum E_LoraLowSpeedOpt {
    /**
     * 默认
     */
    Default = 0,
    /**
     * 开启
     */
    Open = 1,
    /**
     * 关闭
     */
    Close = 2
}


/**
 * $t('enum.E_GatewayOnLineStatus.Online')
 * $t('enum.E_GatewayOnLineStatus.Offline')
 */
export enum E_GatewayOnLineStatus {
    /**
     * 在线
     */
    Online = 1,
    /**
     * 离线
     */
    Offline = 2,
}

/**
 * 网关型号
 * $t('enum.E_GateWayModel.VB22H')
 * $t('enum.E_GateWayModel.VB24H')
 */
export enum E_GateWayModel {
    VB22H = 1,
    VB24H = 2,
}

/**
 * $t('enum.E_DHCPModel.DHCP')
 * $t('enum.E_DHCPModel.Static')
 */
export enum E_DHCPModel {
    DHCP = 1,
    Static = 0,
}

/**
 * 数据上云状态
 * $t('enum.E_DataStatus.NotUpload')
 * $t('enum.E_DataStatus.Upload')
 */
export enum E_DataStatus {
    /**
     * 不上传
     */
    NotUpload = 0,
    /**
     * 上传
     */
    Upload = 1,
}

/**
 * $t('enum.E_GatewayStatus.Offline')
 * $t('enum.E_GatewayStatus.Connecting')
 */
export enum E_GatewayStatus {
    /**
     * 未连接
     */
    Offline = 0,
    /**
     * 已连接
     */
    Connecting = 1,
}

/**
 * 网关类型
 * $t('enum.E_GatewayType.Bluetooth')
 * $t('enum.E_GatewayType.LoRa')
 * $t('enum.E_GatewayType.ZigBee')
 * $t('enum.E_GatewayType.RS485')
 * $t('enum.E_GatewayType.RVT50')
 * $t('enum.E_GatewayType.DTU')
 * $t('enum.E_GatewayType.NGWP02')
 * $t('enum.E_GatewayType.NGWP04')
 * $t('enum.E_GatewayType.DTU_Ethernet')
 */
export enum E_GatewayType {
    /**
     * 蓝牙网关
     */
    Bluetooth = 19,
    /**
     * LoRa网关
     */
    LoRa = 20,
    /**
     * ZigBee网关
     */
    ZigBee = 21,
    /**
     * RS485
     */
    RS485 = 22,
    /**
     * RVT50
     */
    RVT50 = 28,
    /**
     * DTU
     */
    DTU = 53,
    /**
     * NGWP02
     */
    NGWP02 = 54,
    /**
     * DTU(以太网转4G)
     */
    DTU_Ethernet = 55,
    /**
     * NGWP04
     */
    NGWP04 = 56,
}

// export enum E_ConnectType_Bluetooth {
//     MacAddress = '输入网关MAC地址',
// }

/**
 * $t('enum.E_ConnectType_LoRa.EncryptionKey')
 * $t('enum.E_ConnectType_LoRa.FrequencyPair')
 * $t('enum.E_ConnectType_LoRa.BindSensors')
 */
export enum E_ConnectType_LoRa {
    /**
     * 输入网关密钥
     */
    EncryptionKey = 23,
    /**
     * 输入发射频段、接收频段
     */
    FrequencyPair = 24,
    /**
     * 绑定的传感器种类（多选）
     */
    BindSensors = 25,
}

// export enum E_ConnectType_ZigBee {
//     NetworkChannel = '输入网关网络号/通道号',
// }

// export enum E_ConnectType_RS485 {
//     HeartbeatPacket = '输入网关心跳报文',
// }

/**
 * 绑定传感器类型
 * $t('enum.E_BindSensorType.VibrationTypeWiredPowerSupply')
 * $t('enum.E_BindSensorType.NonVibrationMixing')
 */
export enum E_BindSensorType {
    /**
     * 振动类有线供电
     */
    VibrationTypeWiredPowerSupply = 27,
    /**
     * 非振动类混合
     */
    NonVibrationMixing = 26,
}

/**
 * 波形采集模式
 */
export enum E_WaveCollectMode {
    Value_3 = 3,
    Value_6 = 6,
    Value_12 = 12,
    Value_24 = 24,
}

/**
 * 网关升级状态
 * $t('enum.E_GatewayUpgradeStatus.Upgrading')
 * $t('enum.E_GatewayUpgradeStatus.Finished')
 * $t('enum.E_GatewayUpgradeStatus.Failed')
 */
export enum E_GatewayUpgradeStatus {
    /**
     * 升级中
     */
    Upgrading = 1,
    /**
     * 升级完成
     */
    Finished = 2,
    /**
     * 升级失败
     */
    Failed = 3,
}

/**
 * 插卡状态
 * $t('enum.E_CardStatus.NotFound')
 * $t('enum.E_CardStatus.Found')
 */
export enum E_CardStatus {
    /**
     * 未检测到卡
     */
    NotFound = 0,
    /**
     * 已插卡
     */
    Found = 1,
}


/**
 * 注册状态
 * $t('enum.E_RegisterStatus.NotRegister')
 * $t('enum.E_RegisterStatus.HasRegister')
 */
export enum E_RegisterStatus {
    /**
     * 未注册
     */
    NotRegister = 0,
    /**
     * 已注册
     */
    HasRegister = 1,
}

/**
 * wifi状态
 * $t('enum.E_WifiStatus.NoNetwork')
 * $t('enum.E_WifiStatus.HasNetwork')
 */
export enum E_WifiStatus {
    /**
     * 无网络
     */
    NoNetwork = 0,
    /**
     * 有网络
     */
    HasNetwork = 1,
}

export enum E_SensorBindStatus {
    HasBind = 1,
    NotBind = 0,
}

/**
 * Wifi连接状态
 * $t('enum.E_WifiConnectStatus.Connected')
 * $t('enum.E_WifiConnectStatus.NotConnected')
 */
export enum E_WifiConnectStatus {
    /**
     * 已连接
     */
    Connected = 1,
    /**
     * 未连接
     */
    NotConnected = 0,
}

/**
 * 下发状态
 * $t('enum.E_SensorPushStatus.Success')
 * $t('enum.E_SensorPushStatus.Failed')
 * $t('enum.E_SensorPushStatus.Pending')
 * $t('enum.E_SensorPushStatus.HasSend')
 * $t('enum.E_SensorPushStatus.Stopped') 
 */
export enum E_SensorPushStatus {
    /**
     * 成功
     */
    Success = 1,
    /**
     * 失败
     */
    Failed = 2,
    /**
     * 待下发
     */
    Pending = 3,
    /**
     * 已下发
     */
    HasSend = 4,
    /**
     * 终止
     */
    Stopped = 5,
}

export interface IGatewayListPageParams extends IPageParams {
    /**
     * 网关名称
     */
    name?: string
    areaId?: number
    companyId?: number
}

export interface IGateWayListItem {
    /**
     * 网关类型
     */
    gatewayTypeId: E_GatewayType
    areaid?: number;
    /**
     * 区域名称
     */
    areaName?: string;
    companyid?: number;
    /**
     * 公司名称
     */
    companyName?: string;
    createBy?: null;
    createTime?: null;
    delFlag?: number;
    /**
     * ID号
     */
    devID?: string;
    /**
     * IP号
     */
    devip?: number;
    id?: number;
    /**
     * 安装位置
     */
    location?: string;
    /**
     * 网关mac地址
     */
    mac?: string;
    /**
     * 网关名称
     */
    name?: string;
    /**
     * 0未连接 1已连接
     */
    status?: boolean;
    /**
     * 网关类型Id
     */
    type?: string
    /**
     * 网关类型
     */
    typeName?: string;
    updateBy?: null;
    updateTime?: null;

    /**
     * 网关已添加传感器数量
     */
    sensorNum?: number

    /**
     * 波形采集模式
     */
    collectMode?: number

    /**
     * 数据上云状态
     */
    dataStatus?: E_DataStatus

    /**
     * 硬件版本
     */
    hardwareVersion: string
    /**
     * 软件版本
     */
    softwareVersion: string
    /**
     * 固件类型
     */
    firmwareType: string

    /**
     * 升级状态
     */
    upgradeStatus: E_GatewayUpgradeStatus
}

export type IGatewayListPageData = IPageData<IGateWayListItem>

export interface IGatewayType {
    gatewayModel: E_GateWayModel

    dhcp: E_DHCPModel

    /**
     * 静态IP
     */
    staticIp: string
    /**
     * 子网掩码
     */
    subnetMask: string
    /**
     * 网关IP
     */
    gatewayIp: string

    /**
     * 网关类型ID
     */
    gatewayType: E_GatewayType
    /**
     * 接收频段
     */
    acceptTransmission: string;
    /**
     * 通道号
     */
    channelNumber: string;
    /**
     * 连接类型
     */
    connectType: string;
    /**
     * 网关心跳报文
     */
    heartBeat: string;
    id?: number;
    /**
     * 网关网络号
     */
    networkNumber: string;
    /**
     * 密钥
     */
    secret: string;
    /**
     * 绑定传感器种类ID
     */
    sensorKind: number;
    /**
     * 传感器类型 逗号隔开
     */
    sensorType: string;
    /**
     * 发射频段
     */
    transmission: string;
    /**
     * 网关MAC地址
     */
    blueMac: string

    //#region RVT50
    /**
     * 第一通道
     */
    firstChannel: number
    /**
     * 第二通道
     */
    secondChannel: number
    /**
    * 第三通道
    */
    thirdChannel: number
    /**
     * 第四通道
     */
    fourthChannel: number
    /**
     * 转速
     */
    rotateSpeed: number
    /**
     * 转速比值
     */
    speedRatio: number
    //#endregion

    /**
     * 无线通道
     */
    wirelessChannel: number
    /**
     * 频段
     */
    wirelessFrequency: number

    /**
     * 寄存器个数
     */
    tempStorageNum: number
    /**
     * 寄存器起始索引
     */
    tempStorageIndex: number
}

export interface IGatewayCreateParams {
    areaId: number;
    companyId: number;
    /**
     * ID号
     */
    devID: string;
    /**
     * ip
     */
    devIP: string;

    /**
     * 端口号
     */
    devPort: string

    gatewayType: IGatewayType;



    /**
     * 安装位置
     */
    location?: string;
    /**
     * mac
     */
    mac: string;
    /**
     * 网关名称
     */
    name: string;
    /**
     * 0未连接 1已连接
     */
    // status: E_GatewayStatus
    collectMode: E_WaveCollectMode
}


export interface IGatewayItem extends IGatewayCreateParams {
    id: number
    areaName: string
    companyName: string
    collectMode: E_WaveCollectMode
    gatewayType: IGatewayType & { id: number }
}

export interface IGatewayEditParams extends IGatewayCreateParams {
    id: number
    gatewayType: IGatewayType & { id: number }
}

export interface IGatewaySelectListData {
    /**
     * 绑定传感器种类
     */
    sensorKind: IOptionNumberItem[]
    /**
     * 网关类型
     */
    gatewayType: IOptionNumberItem[]
    /**
     * 连接类型
     */
    connectType: IOptionNumberItem[]
}

export interface IGatewayListItem extends IOptionNumberItem {
    gateWayTypeId: number
    /**
     * 暂时无用
     */
    type: number
}

export type IGatewayListData = IGatewayListItem[]


export interface IGatewayGetChannelAndFreqParams {
    gatewayId: string | number
}


export interface IGatewayGetCardParams {
    gatewayId: string | number
}

export interface IGatewayGetIPAndPortParams {
    gatewayId: string | number
}

export interface IGatewayGetNetWorkInfoParams {
    gatewayId: string | number
}

export interface IGatewayQueryNetWorkInfoParams {
    gatewayId: string | number
}

export interface IGatewayQueryNetWorkInfoData {
    cardStatus: E_CardStatus
    createTime: string
    fourGNetwork: string
    fourGSubnet: string
    fourGip: string
    gatewayId: string
    iccid: string
    id: number
    registerStatus: E_RegisterStatus
    signalLevel: number
    updateTime: string
    wifiIp: string
    wifiNetwork: string
    wifiStatus: E_WifiStatus
    wifiSubnet: string
}



export interface IGatewayLoraNetworkBindParams {
    registerId: string
    sensorId: string
}

export interface IGatewayLoraNetworkEditParams {
    /**
     * 传感器密钥
     */
    aesKey: string
    /**
     * 
     */
    id: number
    /**
     * 接收载波反转
     */
    // receiveCarrierReversal: number
    /**
     * 接收频率（起始频点）
     */
    receiveFreq: number
    /**
     * 接收扩频因子
     */
    receiveSpsp: number
    /**
     * 发送载波反转
     */
    // sendCarrierReversal: number
    /**
     * 发射频率（起始频点）
     */
    sendFreq: number
    /**
     * 发射扩频因子
     */
    sendSpsp: number
}

export interface IGatewayLoraNetworkFindListParams {
    companyId: number
    areaId: number
    gatewayName?: string
    gatewayStatus?: E_GatewayOnLineStatus
}

export interface IGatewayLoraNetworkSensorListItem {
    /**
     * 信号等级 1 最好
     */
    signalLevel: number
    /**
     * 绑定状态
     */
    bindStatus: E_SensorBindStatus
    /**
     * 
     */
    createTime: string
    /**
     * 特征值上传时间
     */
    dataTime: string
    /**
     * 
     */
    gatewayId: number
    /**
     * 网关上传次数
     */
    gatewayUploadNum: number
    /**
     * 注册包
     */
    registerId: string
    /**
     * 传感器ID
     */
    sensorId: string
    /**
     * 传感器类型
     */
    sensorType: E_SensorKlass
    /**
     * 信号强度
     */
    sensorSignal: number
    /**
     * 是否在线
     */
    gatewayStatus: E_GatewayStatus
}

export interface IGatewayLoraNetworkFindListItem {
    id: number
    /**
     * 传感器密钥
     */
    aesKey: string
    /**
     * 
     */
    areaId: number
    /**
     * 
     */
    areaName: string
    /**
     * 
     */
    companyId: number
    /**
     * 
     */
    companyName: string
    /**
     * 
     */
    gatewayId: string
    /**
     * 
     */
    gatewayName: string
    /**
     * 接收频率（起始频点）
     */
    receiveFreq: number

    /**
     * 接收扩频因子
     */
    receiveSpsp: number

    /**
     * 发射扩频因子
     */
    sendSpsp: number

    /**
     * 注册Id
     */
    registerId: string
    /**
     * 发射频率（起始频点）
     */
    sendFreq: number
    createTime: string
    gatewayIp: string

    /**
     * 绑定传感器数量
     */
    bindSensorNum: number

    /**
     * 传感器列表
     */
    sensorList: IGatewayLoraNetworkSensorListItem[]
}

export type IGatewayLoraNetworkFindListData = IGatewayLoraNetworkFindListItem[]

export interface IGatewayLoraNetworkFindSensorListParams {
    registerId: string
    sensorId: string
}

export interface IGatewayLoraNetworkSensorItem {
    dataTime: string
    gatewayName: string
    gatewayId: number
    id: number
    num: number
    pushStatus: E_SensorPushStatus
    sensorId: string
    sensorType: E_SensorKlass
    sensorSignal: number
}

export type IGatewayLoraNetworkFindSensorListData = IGatewayLoraNetworkSensorItem[]


export interface IGatewayLoraNetworkStopLoraNetworkingParams {
    registerId: string
    sensorId: string
}

export interface IGatewayLoraNetworkUnbindParams {
    registerId: string
    sensorId: string
}


export interface IGatewayConfig {
    companyName?: string
    areaName?: string

    gatewayMac?: string
    gatewayName?: string
    gatewayTypeId?: E_GatewayType

    /**
     * 创建时间
     */
    createTime?: string
    /**
     * 数据格式
     */
    dataFormat: E_GatewayDataFormat
    /**
     * 以太网0dns
     */
    ethernetDns: string
    /**
     * 以太网1dns
     */
    ethernetDnsOne: string
    /**
     * 以太网0ip
     */
    ethernetIp: string
    /**
     * 以太网1ip
     */
    ethernetIpOne: string
    /**
     * 以太网0模式
     */
    ethernetMode: E_GatewayDHCPModel
    /**
     * 以太网1模式
     */
    ethernetModeOne: E_GatewayDHCPModel
    /**
     * 以太网0网关
     */
    ethernetNetwork: string
    /**
     * 以太网1网关
     */
    ethernetNetworkOne: string
    /**
     * 以太网0掩码
     */
    ethernetSubnet: string
    /**
     * 以太网1掩码
     */
    ethernetSubnetOne: string
    /**
     * 传输协议类型
     */
    frameType: E_GatewayTranslateProtocol
    /**
     * 网关id
     */
    gatewayId: string
    /**
     * 硬件版本号
     */
    hardwareVersion: string
    /**
     * 网关心跳周期
     */
    heartbeat: number
    /**
     * 带宽
     */
    loraBandwidth: string //E_LoraBandwidth
    /**
     * 频点：数组第0个元素代表发射参数，第1个代表接收参数，逗号分割，下同
     */
    loraFreqPoint: string
    /**
     * 前导码长度 格式(发送,接收)
     */
    loraLeadCodeLen: string
    /**
     * 低速优化
     */
    loraLowSpeedOpt:  string //E_LoraLowSpeedOpt
    /**
     * 扩频因子 格式(发送,接收)
     */
    loraSpSp: string
    /**
     * LoRa协议 同步字
     */
    loraSyncWord: number
    /**
     * ModbusTCP/RTU 从机地址
     */
    modbusClientAddr: string
    /**
     * 数据位
     */
    modbusDataBit?: number
    /**
     * 校验位
     */
    modbusParityBit?: string
    /**
     * Modbus RTU启用状态
     */
    modbusRtuStatus?: number
    /**
     * ModbusTCP/RTU 服务端的端口号
     */
    modbusServicePort: number
    /**
     * 停止位
     */
    modbusStopBit?: number
    /**
     * Modbus TCP启用状态
     */
    modbusTcpStatus?: number
    /**
     * modbus_rtu 波特率
     */
    modbusbaudRate?: string
    /**
     * MQTT IP地址或域名
     */
    mqttAddr?: string
    /**
     * MQTT 端口号
     */
    mqttAddrPort?: number
    /**
     * CleanSession
     */
    mqttCleanSession: number
    /**
     * MQTTClientID前缀
     */
    mqttCliectId?: string
    /**
     * MQTT用户名
     */
    mqttName: string
    /**
     * MQTT 发布Qos
     */
    mqttPubQos: number
    /**
     * MQTT密码
     */
    mqttPwd: string
    /**
     * Retain
     */
    mqttRetain: number
    /**
     * MQTT启用状态
     */
    mqttStatus?: number
    /**
     * MQTT 订阅Qos
     */
    mqttSubQos: number
    /**
     * MQTT主题前缀
     */
    mqttTopic: string
    /**
     * MQTT 单位KiB，范围128 ~ 1024
     */
    mqttMessageLenMax: number
    /**
     * 2.4G私有协议 通道号
     */
    sensorChannelNo: number
    /**
     * 蜂窝网络APN
     */
    simApn: string
    /**
     * 蜂窝网络APN 用户名
     */
    simApnName: string
    /**
     * 蜂窝网络APN 密码
     */
    simApnPwd: string
    /**
     * 软件版本号扩展
     */
    softwareVerExtend: string
    /**
     *软件版本号 
     */
    softwareVersion: string
    /**
     * TCP-IP地址或域名
     */
    tcpAddress: string
    /**
     * TCP端口
     */
    tcpPort: number
    /**
     * TCP启用状态
     */
    tcpStatus?: number
    /**
     * 更新时间
     */
    updateTime?: string
    /**
     * 白名单过滤启用状态
     */
    whitelistFilterStatus?: number
    /**
     * Wi-Fi AP模式开关
     */
    wifiApStatus?: number
    /**
     * Wi-Fi 密码
     */
    wifiPwd: string
    /**
     * Wi-Fi ssid
     */
    wifiSsid: string
    /**
     * 同步采集状态
     */
    syncCollectStatus: E_SyncCollectStatus

    /**
     * MCU软件版本
     */
    mcuSoftware: string
    /**
     * 传感器注册状态
     */
    sensorRegistStatus: E_SensorRegisterStatus

    /**
     * 广域网络id
     */
    wanId: string    

    /**
     * 蓝牙名称
     */
    bluetoothName: string

    /**
     * 离线数据状态
     */
    offlineDataStatus: E_OfflineDataStatus

    /**
     * 波特率
     */
    baudRate: number    
    /**
     * 传感器 RS485 校验位
     */
    sensorParityBit: string
    /**传感器 RS485 数据位 */
    sensorDataBit: number
    /**传感器 RS485 停止位 */
    sensorStopBit?: number
}

export type IGatewayConfigEditParams = IGatewayConfig

export interface IGatewayConfigGetParams {
    gatewayId: string | number
}

export type IGatewayConfigGetData = IGatewayConfig

export interface IGatewayConfigGetStateParams {
    gatewayId: string | number
}

export interface IGatewayConfigSensorTerminalParams {
    gatewayId: string | number
    cmd: string
}

export interface IGatewayConfigGetStateData {
    companyName: string
    areaName: string
    gatewayName: string
    gatewayMac: string
    gatewayTypeId: E_GatewayType
    /**
     * 数据格式：0 Raw（透传），1 Json
     */
    dataFormat: E_GatewayDataFormat
    /**
     * 传输协议类型：0 TCP,1 MQTT, 2 Modbus-TCP，3 Modbus-RTU
     */
    frameType: E_GatewayTranslateProtocol
    /**
     * 网关心跳周期
     */
    heartbeat: number
    /**
     * 带宽：7：125KHz 8：250KHz 9：500KHz 格式(发送,接收)
     */
    loraBandwidth: string
    /**
     * 频点：数组第0个元素代表发射参数，第1个代表接收参数，逗号分割
     */
    loraFreqPoint: string
    /**
     * 前导码长度 格式(发送,接收)
     */
    loraLeadCodeLen: string
    /**
     * 低速优化：0：默认 1：开启 2：关闭 格式(发送,接收)
     */
    loraLowSpeedOpt: string
    /**
     * 扩频因子 格式(发送,接收)
     */
    loraSpSp: string
    /**
     * LoRa协议 同步字
     */
    loraSyncWord: number
    /**
     * ModbusTCP/RTU 从机地址
     */
    modbusClientAddr: string
    /**
     * 数据位
     */
    modbusDataBit: number
    /**
     * 校验位
     */
    modbusParityBit: string
    /**
     * Modbus RTU启用状态
     */
    modbusRtuStatus: number
    /**
     * ModbusTCP/RTU 服务端的端口号
     */
    modbusServicePort: number
    /**
     * 停止位
     */
    modbusStopBit: number
    /**
     * Modbus TCP启用状态
     */
    modbusTcpStatus: number
    /**
     * modbus_rtu 波特率
     */
    modbusbaudRate: string
    /**
     * MQTT IP地址或域名
     */
    mqttAddr: string
    /**
     * MQTT 端口号
     */
    mqttAddrPort: number
    /**
     * CleanSession
     */
    mqttCleanSession: number
    /**
     * MQTTClientID前缀
     */
    mqttCliectId: string
    /**
     * MQTT用户名
     */
    mqttName: string
    /**
     * MQTT 发布Qos
     */
    mqttPubQos: number
    /**
     * MQTT密码
     */
    mqttPwd: string
    /**
     * Retain
     */
    mqttRetain: number
    /**
     * MQTT启用状态
     */
    mqttStatus: number
    /**
     * MQTT 订阅Qos
     */
    mqttSubQos: number
    /**
     * MQTT主题前缀
     */
    mqttTopic: string
    /**
     * 离线数据状态：1：允许 0：不允许
     */
    offlineDataStatus: E_OfflineDataStatus
    /**
     * 2.4G私有协议 通道号
     */
    sensorChannelNo: number
    /**
     * 传感器 RS485 数据位
     */
    sensorDataBit: number
    /**
     * 传感器 RS485 校验位
     */
    sensorParityBit: string
    /**
     * 传感器 RS485 停止位
     */
    sensorStopBit: number
    /**
     * 传感器注册状态：1：允许 0：不允许
     */
    sensorRegistStatus: E_SensorRegisterStatus
    /**
     * 蜂窝网络APN
     */
    simApn: string
    /**
     * 蜂窝网络APN 用户名
     */
    simApnName: string
    /**
     * 蜂窝网络APN 密码
     */
    simApnPwd: string
    /**
     * 同步采集状态：0 关闭 1 开启
     */
    syncCollectStatus: E_SyncCollectStatus
    /**
     * TCP-IP地址或域名
     */
    tcpAddress: string
    /**
     * TCP端口
     */
    tcpPort: number
    /**
     * TCP启用状态
     */
    tcpStatus: number
    /**
     * 广域网络id
     */
    wanId: string
    /**
     * 白名单过滤启用状态
     */
    whitelistFilterStatus: number
    /**
     * Wi-Fi AP模式开关
     */
    wifiApStatus: number
    /**
     * Wi-Fi 密码
     */
    wifiPwd: string
    /**
     * Wi-Fi ssid
     */
    wifiSsid: string
    /**
     * 蓝牙名称
     */
    bluetoothName: string
    /**
     * 波特率
     */
    baudRate: number

    /**
     * 创建时间
     */
    createTime: string

    /**
     * 故障码
     */
    errorCode: number

    /**
     * 以太网0dns
     */
    ethernetDns: string
    /**
     * 以太网1dns
     */
    ethernetDnsOne: string
    /**
     * 以太网0ip
     */
    ethernetIp: string
    /**
     * 以太网1ip
     */
    ethernetIpOne: string
    /**
     * 以太网0模式
     */
    ethernetMode: E_GatewayDHCPModel
    /**
     * 以太网1模式
     */
    ethernetModeOne: E_GatewayDHCPModel
    /**
     * 以太网0网关
     */
    ethernetNetwork: string
    /**
     * 以太网1网关
     */
    ethernetNetworkOne: string
    /**
     * 以太网0掩码
     */
    ethernetSubnet: string
    /**
     * 以太网1掩码
     */
    ethernetSubnetOne: string
    /**
     * 网关id
     */
    gatewayId: string
    /**
     * 硬件版本号
     */
    hardwareVersion: string

    /**
     * 配置参数修改次数
     */
    settingNum: number

    /**
     * SIM卡 iccid
     */
    simIccis: string

    /**
     * SIM卡ip
     */
    simIp: string

    /**
     * SIM卡信号强度
     */
    simSignal: number

    /**
     * SIM卡状态位
     */
    simStatus: E_SimStatus

    /**
     * 软件版本号扩展
     */
    softwareVerExtend: string
    /**
     *软件版本号 
     */
    softwareVersion: string
    /**
     * 版本号
     */
    mcuSoftware: string
    /**
     * 更新时间
     */
    updateTime: string

    /**
     * wifi模块dns
     */
    wifiDns: string
    /**
     * wifi模块IP
     */
    wifiIp: string
    /**
     * wifi模块网关
     */
    wifiNetwork: string
    /**
     * wifi模块掩码
     */
    wifiSubnet: string

    /**
     * Wi-Fi信号强度
     */
    wifiSignal: number

    /**
     * Wi-Fi连接状态
     */
    wifiStatus: E_WifiConnectStatus
}


